/* eslint-disable max-lines-per-function */
import React from 'react';
import {connect} from 'react-redux';
import {Form, Input, Button, message} from 'lark';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import ImgIcon from '~/component/ImgIcon';
import {LOGIN_TO} from '~/constant/login';
import {sendSmsCodeService} from '~/service/login';
import './index.less';
import {preThrottle} from '../../../../utils/function';

const THROTTLE_DELAY = 500;
const ONE_SECONDS = 1000;
const WAIT_TIME = 59;
const CAPTCHA_CODE_LENGTH = 4;
const SMS_CODE_LENGTH = 6;

class LoginForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            submitDisable: false,
            waitTime: WAIT_TIME,
            captchaTimeStamp: new Date().valueOf(),
        };
    }

    /**
     * 发送验证码
     */
    onSendSmsCode = preThrottle(() => {
        const {form: {validateFields}, params: {code}, setErrMsg} = this.props;
        validateFields(['phone'], async errors => {
            if (errors) {
                return;
            }
            try {
                const smsRes = await sendSmsCodeService({code});
                if (smsRes.success) {
                    message.success('验证码已发送，请查收');
                    this.setState({loading: true}, () => {
                        this.count();
                        setErrMsg('');
                    });
                }
                else {
                    this.setState({loading: false});
                    setErrMsg(smsRes.msg);
                }
            }
            catch (error) {
                if (error.msg) {
                    this.setState({loading: false});
                    setErrMsg(error.msg);
                }
            }
        });
    }, THROTTLE_DELAY);

    onRefreshButtonClick = preThrottle(() => {
        this.refreshCaptchaTimeStamp();
    }, THROTTLE_DELAY);

    handleAccountPasswordSubmit = preThrottle(() => {
        const {form: {validateFields}, handleLogin, setErrMsg} = this.props;
        validateFields((errors, values) => {
            if (errors) {
                return;
            }
            const {username, password, captcha} = values;
            setErrMsg('');
            try {
                handleLogin({
                    username: username.split('@')[0],
                    password,
                    code: captcha,
                });
            }
            catch (error) {
                if (error.msg) {
                    setErrMsg(error.msg);
                }
            }
        });
    }, THROTTLE_DELAY);

    handlePhoneCodeSubmit = preThrottle(() => {
        const {form: {validateFields}, handleLogin, setErrMsg} = this.props;
        validateFields((errors, values) => {
            if (errors) {
                return;
            }
            const {smsCode} = values;
            setErrMsg('');
            try {
                handleLogin({smsCode});
            }
            catch (error) {
                if (error.msg) {
                    setErrMsg(error.msg);
                }
            }
        });
    }, THROTTLE_DELAY);

    /**
     * 倒计时
     */
    count = () => {
        let {waitTime} = this.state;
        const timer = setInterval(() => {
            this.setState({waitTime: (--waitTime)}, () => {
                if (waitTime <= 0) {
                    clearInterval(timer);
                    this.setState({loading: false, waitTime: WAIT_TIME});
                }
            });
        }, ONE_SECONDS);
    };

    refreshCaptchaTimeStamp = () => {
        this.setState({
            captchaTimeStamp: new Date().valueOf()
        });
    };

    getCaptchaUrl = () => {
        const {captchaTimeStamp} = this.state;
        const {params: {captchaId = ''}} = this.props;
        return `https://captcha.genshuixue.com/dogfood/generate?captchaId=${captchaId}&timestamp=${captchaTimeStamp}&output=binary&width=120&height=48&length=4&engine=digit`;
    };

    /**
     * 渲染账号密码登录表单
     */
    renderAccountPassword = () => {
        const {form: {getFieldDecorator}, params: {isNeedToVerify = false}, agent: {isMobile}} = this.props;
        const className = isMobile ? 'h5-login-form' : 'web-login-form';
        return (
            <div className={className}>
                <Form.Item>
                    {
                        getFieldDecorator('username', {
                            rules: [
                                {
                                    required: true,
                                    message: '请输入邮箱前缀',
                                },
                                {
                                    pattern: /^\S+$/,
                                    message: '不允许出现空格'
                                },
                            ]
                        })(
                            <Input
                                prefix={<ImgIcon type="mail" />}
                                placeholder="请输入邮箱前缀"
                                autoComplete="off"
                                onPressEnter={this.handleAccountPasswordSubmit}
                            />
                        )
                    }
                </Form.Item>
                <Form.Item>
                    {
                        getFieldDecorator('password', {
                            rules: [
                                {
                                    required: true,
                                    message: '请输入密码',
                                },
                            ]
                        })(
                            <Input.Password
                                prefix={<ImgIcon type="lock" />}
                                placeholder="请输入密码"
                                onPressEnter={this.handleAccountPasswordSubmit}
                            />
                        )
                    }
                </Form.Item>
                {isNeedToVerify
                    && (
                        <Form.Item>
                            {getFieldDecorator('captcha', {
                                rules: [
                                    {
                                        required: true,
                                        message: '请输入验证码'
                                    },
                                ]
                            })(
                                isMobile
                                    ? (
                                        <div className="captcha-wrapper">
                                            <Input
                                                prefix={<ImgIcon type="code" />}
                                                placeholder="请输入验证码"
                                                class="valid-input"
                                                autoComplete="off"
                                                maxLength={CAPTCHA_CODE_LENGTH}
                                                onPressEnter={this.handleAccountPasswordSubmit}
                                                suffix={(
                                                    <div className="captcha-img-button-wrapper">
                                                        <img
                                                            src={this.getCaptchaUrl()} alt="captcha"
                                                            className="captcha-img"
                                                        />
                                                        <Button
                                                            type="link"
                                                            onClick={this.onRefreshButtonClick}
                                                            class="captcha-button"
                                                        >
                                                            <span className="captcha-button-text">换一张</span>
                                                        </Button>
                                                    </div>
                                                )}
                                            />
                                        </div>
                                    )
                                    : (
                                        <div className="captcha-wrapper">
                                            <Input
                                                prefix={<ImgIcon type="code" />}
                                                placeholder="请输入验证码"
                                                class="valid-input"
                                                autoComplete="off"
                                                maxLength={CAPTCHA_CODE_LENGTH}
                                                onPressEnter={this.handleAccountPasswordSubmit}
                                            />
                                            <img src={this.getCaptchaUrl()} alt="captcha" className="captcha-img" />
                                            <Button
                                                type="link"
                                                onClick={this.onRefreshButtonClick}
                                            >
                                                <span className="captcha-button-text">换一张</span>
                                            </Button>
                                        </div>
                                    )
                            )
                            }
                        </Form.Item>
                    )
                }
                <Button
                    class="confirm-button"
                    onClick={this.handleAccountPasswordSubmit}
                >
                    登录
                </Button>
            </div>
        );
    };

    /**
     * 渲染手机验证码表单
     */
    renderPhoneCode = () => {
        const {form: {getFieldDecorator}, params: {phone = ''}, agent: {isMobile}} = this.props;
        const {loading, submitDisable, waitTime} = this.state;
        const className = isMobile ? 'h5-login-form' : 'web-login-form';
        return (
            <div className={className}>
                <Form.Item>
                    {
                        getFieldDecorator('phone', {
                            rules: [
                                {
                                    required: true,
                                    message: '手机号不能为空',
                                }
                            ],
                            initialValue: phone
                        })(<Input
                            prefix={<ImgIcon type="phone" />}
                            placeholder="请输入手机号"
                            disabled
                            autoComplete="off"
                            class="field-phone"
                            onPressEnter={this.handlePhoneCodeSubmit}
                        />)
                    }
                </Form.Item>
                <Form.Item>
                    {
                        getFieldDecorator('smsCode', {
                            rules: [
                                {
                                    required: true,
                                    message: '请输入六位验证码',
                                }
                            ]
                        })(
                            isMobile
                                ? (
                                    <Input
                                        prefix={<ImgIcon type="code" class="login-form-input-icon" />}
                                        placeholder="请输入六位验证码"
                                        class="field-smscode"
                                        autoComplete="off"
                                        maxLength={SMS_CODE_LENGTH}
                                        onPressEnter={this.handlePhoneCodeSubmit}
                                        suffix={(
                                            <Button
                                                class={classnames('smscode-button',
                                                    loading ? 'disable-valid-btn' : 'valid-btn')}
                                                onClick={this.onSendSmsCode}
                                                disabled={loading}
                                            >
                                                {loading ? `重新发送(${waitTime}s)` : '发送验证码'}
                                            </Button>
                                        )}
                                    />
                                )
                                : (
                                    <div className="smscode-wrapper">
                                        <Input
                                            prefix={<ImgIcon type="code" class="login-form-input-icon" />}
                                            placeholder="请输入六位验证码"
                                            class="field-smscode"
                                            autoComplete="off"
                                            maxLength={SMS_CODE_LENGTH}
                                            onPressEnter={this.handlePhoneCodeSubmit}
                                        />
                                        <Button
                                            class={classnames('smscode-button',
                                                loading ? 'disable-valid-btn' : 'valid-btn')}
                                            onClick={this.onSendSmsCode}
                                            disabled={loading}
                                        >
                                            {loading ? `重新发送(${waitTime}s)` : '发送验证码'}
                                        </Button>
                                    </div>
                                )
                        )}
                </Form.Item>
                <Button
                    class="confirm-button"
                    disabled={submitDisable}
                    onClick={this.handlePhoneCodeSubmit}
                >
                    登录
                </Button>
            </div>
        );
    };

    render() {
        const {params: {to}} = this.props;
        if (to === LOGIN_TO.ACCOUNT_PASSWORD) {
            return this.renderAccountPassword();
        }
        if (to === LOGIN_TO.PHONE_CODE) {
            return this.renderPhoneCode();
        }
        return this.renderAccountPassword();
    }
}

LoginForm.propTypes = {
    form: PropTypes.shape({
        getFieldDecorator: PropTypes.func.isRequired,
        validateFields: PropTypes.func.isRequired,
        setFields: PropTypes.func.isRequired,
        getFieldValue: PropTypes.func.isRequired
    }).isRequired,
    params: PropTypes.shape({
        to: PropTypes.string.isRequired,
        isNeedToVerify: PropTypes.bool,
        captchaId: PropTypes.string,
        phone: PropTypes.string,
        code: PropTypes.string,
    }).isRequired,
    handleLogin: PropTypes.func.isRequired,
    setErrMsg: PropTypes.func.isRequired,
    agent: PropTypes.shape({
        isMobile: PropTypes.bool.isRequired
    }).isRequired,
};


export default Form.create({})(connect(({agent}) => ({agent}))(LoginForm));
